export default {
    pageName: 'ภาพรวมการมาทำงาน',
    search: {
        title: '',
        placeholder: 'ค้นหาสำนักงาน'
    },
    people: 'คน',
    detail: {
        title: 'รายละเอียด',
        present: 'ตรงเวลา',
        late: 'สาย',
        halfDay: 'ขาดครึ่งวัน',
        absent: 'ขาดเต็มวัน',
        leave: 'ลา'
    },
    header: {
        full: 'สำนักงาน',
        sub: 'ชื่อย่อ'
    }
}
